// Keep an account session across report navigation; revoke it when app authentication ends.
const sessions = new Map()

export function getStripeConnectSession(accountKey, initialize) {
  if (!sessions.has(accountKey)) sessions.set(accountKey, initialize())
  return sessions.get(accountKey)
}

export async function logoutStripeConnectSessions() {
  const previous = [...sessions.values()]
  sessions.clear()
  await Promise.allSettled(previous.map(instance => Promise.resolve().then(() => instance.logout())))
}
